// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/sensor/v1/raw_storage.proto (package msh.trait.sensor.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Error } from "../../../common/v1/common_pb";

/**
 * This trait is used for controlling raw sensor / recording storage on the cloud
 *
 * @generated from message msh.trait.sensor.v1.RawStorageTrait
 */
export const RawStorageTrait = proto3.makeMessageType(
  "msh.trait.sensor.v1.RawStorageTrait",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(RawStorageTrait_StatusCode) },
    { no: 2, name: "last_error", kind: "message", T: Error },
    { no: 3, name: "last_updated", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from enum msh.trait.sensor.v1.RawStorageTrait.StatusCode
 */
export const RawStorageTrait_StatusCode = proto3.makeEnum(
  "msh.trait.sensor.v1.RawStorageTrait.StatusCode",
  [
    {no: 0, name: "STATUS_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_CODE_RUNNING", localName: "RUNNING"},
    {no: 2, name: "STATUS_CODE_STOPPED", localName: "STOPPED"},
    {no: 3, name: "STATUS_CODE_CANCELLED", localName: "CANCELLED"},
    {no: 4, name: "STATUS_CODE_ERROR", localName: "ERROR"},
    {no: 5, name: "STATUS_CODE_PREPARING_UPLOAD", localName: "PREPARING_UPLOAD"},
    {no: 6, name: "STATUS_CODE_UPLOADING", localName: "UPLOADING"},
    {no: 7, name: "STATUS_CODE_ALREADY_RECORDING", localName: "ALREADY_RECORDING"},
    {no: 8, name: "STATUS_CODE_START_REQUESTED", localName: "START_REQUESTED"},
    {no: 9, name: "STATUS_CODE_STORAGE_CONFIRMED", localName: "STORAGE_CONFIRMED"},
    {no: 10, name: "STATUS_CODE_STORAGE_DELETED", localName: "STORAGE_DELETED"},
  ],
);

/**
 * ----- COMMANDS -----//
 *
 * @generated from message msh.trait.sensor.v1.RawStorageTrait.SetRecording
 */
export const RawStorageTrait_SetRecording = proto3.makeMessageType(
  "msh.trait.sensor.v1.RawStorageTrait.SetRecording",
  () => [
    { no: 1, name: "command", kind: "enum", T: proto3.getEnumType(RawStorageTrait_SetRecording_Command) },
    { no: 2, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "user_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "RawStorageTrait_SetRecording"},
);

/**
 * @generated from enum msh.trait.sensor.v1.RawStorageTrait.SetRecording.Command
 */
export const RawStorageTrait_SetRecording_Command = proto3.makeEnum(
  "msh.trait.sensor.v1.RawStorageTrait.SetRecording.Command",
  [
    {no: 0, name: "COMMAND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMMAND_START", localName: "START"},
    {no: 2, name: "COMMAND_STOP", localName: "STOP"},
    {no: 3, name: "COMMAND_CANCEL", localName: "CANCEL"},
  ],
);

/**
 * @generated from message msh.trait.sensor.v1.RawStorageTrait.SetStorageUrl
 */
export const RawStorageTrait_SetStorageUrl = proto3.makeMessageType(
  "msh.trait.sensor.v1.RawStorageTrait.SetStorageUrl",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "RawStorageTrait_SetStorageUrl"},
);

/**
 * ----------- EVENTS ----------- //
 *
 * @generated from message msh.trait.sensor.v1.RawStorageTrait.RecordingEvent
 */
export const RawStorageTrait_RecordingEvent = proto3.makeMessageType(
  "msh.trait.sensor.v1.RawStorageTrait.RecordingEvent",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(RawStorageTrait_StatusCode) },
    { no: 2, name: "last_error", kind: "message", T: Error },
    { no: 3, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "creation_time", kind: "message", T: Timestamp },
    { no: 5, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
  {localName: "RawStorageTrait_RecordingEvent"},
);

/**
 * @generated from message msh.trait.sensor.v1.RawStorageTrait.GeneratingUrlEvent
 */
export const RawStorageTrait_GeneratingUrlEvent = proto3.makeMessageType(
  "msh.trait.sensor.v1.RawStorageTrait.GeneratingUrlEvent",
  () => [
    { no: 1, name: "creation_time", kind: "message", T: Timestamp },
    { no: 2, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "RawStorageTrait_GeneratingUrlEvent"},
);

